import * as AvailNow from './AvailNow';

window.displayAvailNow = AvailNow.display;



// WEBPACK FOOTER //
// ./src/index_prod.js